import { Command as CommandPrimitive } from 'cmdk';
import { ArrowLeftIcon, SearchIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

type MenuSearchRowProps = React.ComponentProps<typeof CommandPrimitive.Input> & {
  onBack?: () => void;
};

/** Search input for a cmdk menu, with a back button in place of the search icon when `onBack` is set. */
export const MenuSearchRow = ({ placeholder, onBack, ...inputProps }: MenuSearchRowProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-10 shrink-0 items-center gap-2 border-b border-stroke px-2">
      {onBack ? (
        <Button
          variant="ghost-neutral"
          size="icon-xs"
          aria-label={t('common.back')}
          onClick={onBack}
        >
          <ArrowLeftIcon />
        </Button>
      ) : (
        <SearchIcon className="size-4 shrink-0 text-foreground-muted" />
      )}
      <CommandPrimitive.Input
        autoFocus
        placeholder={placeholder ?? t('common.search_dots')}
        className="h-full flex-1 bg-transparent text-sm leading-5 outline-hidden placeholder:text-foreground-muted"
        {...inputProps}
      />
    </div>
  );
};
